<template>
	<l-marker :lat-lng="latLng">
		<l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
			<div
				class="w-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-6100"
			>
				<svg
					class="w-full"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 39 59.7"
					fill="#454545"
				>
					<g id="Layer_2" data-name="Layer 2">
						<g id="Layer_1-2" data-name="Layer 1">
							<path
								class="cls-1"
								d="M19.5,0C30.2,0,39,9.3,39,20.9a33.2,33.2,0,0,1-3.1,12.7,82.3,82.3,0,0,1-6.8,12.8c-2.5,4-5,7.4-6.9,9.9L20,59.1l-.5.6-.5-.6-2.2-2.8c-1.9-2.5-4.4-5.9-6.9-9.9A82.3,82.3,0,0,1,3.1,33.6,33.2,33.2,0,0,1,0,20.9C0,9.3,8.8,0,19.5,0Z"
							/>
						</g>
					</g>
				</svg>
				<div
					class="p-1 absolute top-0 left-1/2 transform -translate-x-1/2 text-white text-center text-base font-sans"
				></div>
			</div>
		</l-icon>
	</l-marker>
</template>

<script>
import { LMarker, LPopup, LIcon, LCircle } from "vue2-leaflet";

export default {
	props: {
		// deprecated
		search: {
			type: Object,
			required: false,
		},
		geo: {
			type: Object,
			required: false,
			default: null,
		},
	},
	components: {
		LIcon,
		LMarker,
		LPopup,
		LCircle,
	},
	data() {
		return {
			staticAnchor: [16, 37],
		};
	},
	computed: {
		latLng() {
			let coordinates = this.geo.coordinates;

			return [coordinates[1], coordinates[0]];
		},
	},
};
</script>
